module.exports = __webpack_public_path__ + "static/media/logo.033c2ecc.png";